import React from "react";
import { Grid } from "semantic-ui-react";
import { Button, Empty, Tabs, Row, Pagination, Badge } from "antd";
import _ from "lodash";

import AlertNotice from "../common/Alert";
import CampaignList from "./CampaignList";

const { TabPane } = Tabs;

const Campaigns = ({
  campaigns,
  onDeleteCampaign,
  onClose,
  onOpen,
  modalState,
  confirm,
  error,
  editDraft,
  onCreateCampaign,
  handleChange,
  onCustomTemplate,
  state
}) => {
  const campaignsDrafts = campaigns && _.filter(campaigns, { status: "draft" });
  const campaignsSends = campaigns && _.filter(campaigns, { status: "sent" });

  return (
    <div>
      <Row>
        <div style={{ marginBottom: 30 }}>
          {error.campaignError !== null && (
            <AlertNotice message={error.campaignError} type={error.type} />
          )}
        </div>
        <h2>Campaign</h2>
        <Button
          style={{ float: "right" }}
          onClick={onCustomTemplate}
          type="primary"
          size="default"
        >
          Create Campaign
        </Button>
      </Row>
      <Tabs defaultActiveKey="1">
        <TabPane tab="Campaigns" key="1">
          <Grid columns={1} padded>
            <Grid.Row style={{ justifyContent: "center" }}>
              {campaignsSends && campaignsSends.length < 1 ? (
                <Empty
                  description="No Data Create Campaign"
                  style={{ marginTop: 100 }}
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                />
              ) : (
                campaignsSends &&
                campaignsSends.length > 0 &&
                campaignsSends
                  .slice(state.minValue, state.maxValue)
                  .map(cam => (
                    <Grid.Column key={cam.id}>
                      <CampaignList
                        campaign={cam}
                        onDeleteCampaign={onDeleteCampaign}
                        modalState={modalState}
                        onOpen={onOpen}
                        onClose={onClose}
                        confirm={confirm}
                      />
                    </Grid.Column>
                  ))
              )}
            </Grid.Row>
          </Grid>
          <Pagination
            style={{ float: "right" }}
            onChange={handleChange}
            pageSize={10}
            defaultCurrent={1}
            total={campaignsSends && campaignsSends.length}
          />
        </TabPane>
        <TabPane
          tab={
            <p>
              Draft Campaign
              {campaignsDrafts && campaignsDrafts.length > 0 ? (
                <Badge dot />
              ) : null}
            </p>
          }
          key="2"
        >
          <Grid.Row style={{ justifyContent: "center" }}>
            {campaignsDrafts && campaignsDrafts.length < 1 ? (
              <Empty
                description="No Data Create Campaign"
                style={{ marginTop: 100 }}
                image={Empty.PRESENTED_IMAGE_SIMPLE}
              />
            ) : (
              campaignsDrafts &&
              campaignsDrafts.map(cam => (
                <Grid.Column key={cam.id}>
                  <CampaignList
                    editDraft={editDraft}
                    campaign={cam}
                    onDeleteCampaign={onDeleteCampaign}
                    modalState={modalState}
                    onOpen={onOpen}
                    onClose={onClose}
                    confirm={confirm}
                  />
                </Grid.Column>
              ))
            )}
          </Grid.Row>
        </TabPane>
      </Tabs>
    </div>
  );
};

export default Campaigns;
